
import { View, Grid, useTheme, Card } from "@aws-amplify/ui-react";

//import BarChart from '../../../components/Charts/BarChart';
import HeatMap from '../../../components/Charts/HeatMap';
import GaugeMeter from '../../../components/gaugemeter/GaugeMeter';
import ModelPerformanceTable from '../../../components/modelperformancetable/ModelPerformanceTable';
import React from 'react';

const Classification = () => {
    const { tokens } = useTheme();
    return (
        <>
            

            <View borderRadius="5px" maxWidth="100%" padding="0rem" minHeight="100vh" >
                <View className="emoji"
                as="div"
                backgroundColor="var(--amplify-colors-white)"
                borderRadius="15px"
                border="1px solid #e9e9e9"
                color="#242424"
                height="2.6rem"
                maxWidth="100%"
                padding="0.5rem"
                fontSize={14}
                fontWeight={400}
                width="10rem"
                textAlign={'center'}
                // onClick={() => alert('')}
                >
                {"🤗  Hugging Face"}
                </View>

                <Grid
                    width="100%"
                    templateColumns={{ base: "1fr", large: "1fr 1fr" }}
                    gap={tokens.space.xl}
                    marginTop={tokens.space.large}
                >
                    <View columnSpan={{ base: 1, large: 2 }}>
                        <Grid templateColumns={{ base: "1fr", large: "1fr 2fr" }} gap={tokens.space.xl}>
                            <View>
                                <Card className="aipresettask">
                                    <h4 className="mb-4">Model Performance</h4>
                                    <GaugeMeter />
                                </Card>
                            </View>
                            <View>
                                <ModelPerformanceTable />
                            </View>
                        </Grid>
                    </View>
                </Grid>

                <Grid
                    marginTop={tokens.space.xl}
                    templateColumns={{ large: "1fr 1fr", base: "1fr 1fr", medium: "1fr", small: '1fr' }}
                    templateRows={{ base: "repeat(2, auto)", large: "repeat(2, auto)" }}
                    gap={tokens.space.xl}
                >
                    <View columnSpan={[1, 1]} >
                        <Card className="aipresettask" style={{ width: '100%' }}>
                            <h4 className="mb-4">Tagging Metrics</h4>
                            <div className="chart-container">
                                {/* <BarChart /> */}
                            </div>
                        </Card>
                    </View>

                    <View columnSpan={[1, 1]}>
                        <Card className="aipresettask" style={{ width: '100%' }}>
                            <h4 className="mb-4">Distribution of Tags in the Train Dataset</h4>
                            <div className="chart-container">
                                <HeatMap />
                            </div>
                        </Card>
                    </View>
                </Grid>
            </View>
        </>

    )
}

export default Classification